import VeriffTestView from '../../views/Veriff/index.jsx';
import { Container } from './styles.js';

function VeriffTest() {


  return (
      <Container>
      <VeriffTestView/>
      </Container>
  );
}

export default VeriffTest;
